import type { ValueOf } from 'type-fest';

import type { Locale } from '@change-corgi/config/locales';

import { intlPluralRulesLocaleMapping } from '#config/intl-pluralrules';

import { loadMissingFeatures } from '../polyfills';
import type { IntlCheck } from '../types';

const importMapping: Record<ValueOf<typeof intlPluralRulesLocaleMapping>, () => Promise<unknown>> = {
	en: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/en" */ '@formatjs/intl-pluralrules/locale-data/en.js'),
	de: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/de" */ '@formatjs/intl-pluralrules/locale-data/de.js'),
	es: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/es" */ '@formatjs/intl-pluralrules/locale-data/es.js'),
	fr: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/fr" */ '@formatjs/intl-pluralrules/locale-data/fr.js'),
	hi: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/hi" */ '@formatjs/intl-pluralrules/locale-data/hi.js'),
	it: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/it" */ '@formatjs/intl-pluralrules/locale-data/it.js'),
	ja: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/ja" */ '@formatjs/intl-pluralrules/locale-data/ja.js'),
	ko: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/ko" */ '@formatjs/intl-pluralrules/locale-data/ko.js'),
	pt: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/pt" */ '@formatjs/intl-pluralrules/locale-data/pt.js'),
	ru: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/ru" */ '@formatjs/intl-pluralrules/locale-data/ru.js'),
	id: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/id" */ '@formatjs/intl-pluralrules/locale-data/id.js'),
	tr: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/tr" */ '@formatjs/intl-pluralrules/locale-data/tr.js'),
	th: async () =>
		import(/* webpackChunkName: "polyfill/intl-pluralrules/th" */ '@formatjs/intl-pluralrules/locale-data/th.js'),
};

export async function loadPolyfill(locale: string, deps: readonly IntlCheck[]): Promise<void> {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const intlLocale = intlPluralRulesLocaleMapping[locale as Locale];
	await loadMissingFeatures(deps, locale);
	await import(/* webpackChunkName: "polyfill/intl-pluralrules/polyfill" */ '@formatjs/intl-pluralrules/polyfill.js');
	await importMapping[intlLocale]();
}
